import { render, staticRenderFns } from "./MyPageChildren.vue?vue&type=template&id=a98a1014&scoped=true"
import script from "./MyPageChildren.vue?vue&type=script&lang=ts"
export * from "./MyPageChildren.vue?vue&type=script&lang=ts"
import style0 from "./MyPageChildren.vue?vue&type=style&index=0&id=a98a1014&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98a1014",
  null
  
)

export default component.exports